import { FormResource } from "../locales";

export const form: FormResource = {
    rangeOverflow: "La valeur ne peut pas être supérieure à {{max}}.",
    rangeUnderflow: "La valeur ne peut pas être inférieure à {{min}}.",
    required: "Champ requis.",
    invalidEmail: "Adresse e-mail invalide.",
};
